import React from 'react';

import imgM from '../../assets/image/home-6/png/hero-mobile1.png';

const Hero = ({ className, ...rest }) => {
  return (
    <div className={className} {...rest}>
      <div className="container position-static">
        <div className="row align-items-center justify-content-center position-static">
          {/* Hero Image */}
          <div className="col-xl-6 col-lg-6 col-md-7 col-xs-8 position-static">
            <div>
              <img
                className="w-90"
                src={imgM}
                alt=""
                data-aos="fade-up"
                data-aos-delay={500}
                style={{ maxWidth: '100%' }}
              />
            </div>
          </div>
          {/* End Hero Image */}
          {/* Hero Content */}
          <div className="col-lg-6 col-md-9 col-sm-11">
            <div
              className="mt-8 mt-lg-0 pr-md-11 pr-lg-0 pr-xl-10"
              data-aos="fade-left"
              data-aos-delay={750}
            >
              <h1 className="font-size-13 mb-8 pr-sm-18 pr-md-8 pr-lg-0 line-height-84">ONCE!!</h1>
              <p className="font-size-7 mb-0 pr-sm-10 pr-md-10 pr-lg-0 pr-xl-18">
                LINEアカウントを友達追加するだけでTWICEのニュースを取得できます。ニュースは毎日botが自動更新。TWICEの写真検索機能付き。
              </p>
              <div className="mt-10">
                <a
                  href="https://lin.ee/0FnUr8v"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-dark-green btn-3 rounded-5 font-size-9"
                >
                  友達追加する
                </a>
              </div>
            </div>
          </div>
          {/* End Hero Content */}
        </div>
      </div>
    </div>
  );
};

export default Hero;
